import Vue from 'vue'
import {
  Button,
  Calendar,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Circle,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  Form,
  Icon,
  Image as VanImage,
  ImagePreview,
  List,
  Loading,
  NoticeBar,
  Overlay,
  Picker,
  Popup,
  PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Search,
  Skeleton,
  Slider,
  Stepper,
  Swipe,
  SwipeItem,
  Switch,
  Tab,
  Tabs,
  Toast,
  Uploader,
  DropdownMenu,
  DropdownItem,
} from 'vant'

// 仅注册实际用到的组件/插件，避免全量引入导致首屏包膨胀
const components = [
  Button,
  Calendar,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Circle,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Field,
  Form,
  Icon,
  VanImage,
  List,
  Loading,
  NoticeBar,
  Overlay,
  Picker,
  Popup,
  PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Search,
  Skeleton,
  Slider,
  Stepper,
  Swipe,
  SwipeItem,
  Switch,
  Tab,
  Tabs,
  Uploader,
  DropdownMenu,
  DropdownItem,
]

const plugins = [Toast, Dialog, ImagePreview]

components.forEach(component => Vue.use(component))
plugins.forEach(plugin => Vue.use(plugin))



// WEBPACK FOOTER //
// ./src/plugins/vant.js